import React from "react"
import theme from "theme"

const PageHeading = props => (
  <div
    css={{
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: 24,
      padding: "24px 24px 72px",
      borderBottom: `2px solid ${theme.black}`,
      [theme.mobile]: {
        gridTemplateColumns: "1fr",
      },
    }}
    {...props}
  />
)

export default PageHeading
